module.exports = __webpack_public_path__ + "static/media/mission-vision_card.e30357d6.jpg";